import { extend, setInteractionMode } from 'vee-validate'
import * as rules from 'vee-validate/dist/rules'
import { required } from 'vee-validate/dist/rules'

setInteractionMode('eager')

Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule])
})

extend('required', {
  ...required,
  message: 'This field is required.'
})

extend('zipcode', {
  params: ['regex'],
  validate: (value, { regex }) => {
    return regex.test(value)
  },
  message: 'The postal code is in the wrong format.'
})
